export default function filterEmptyTextArrays(array = []) {
  if (!Array.isArray(array)) {
    return array;
  }
  return array
    .filter(item => item !== "")
    .map(item => filterEmptyTextArrays(item));
}
